import {Product} from "../types/products";
import {addLinkedToProduct, toProduct, toProductMap} from "./dto/products";
import {apiCall, HttpMethod} from "./index";
import type BEStripe from "stripe";

export async function getProducts(all: boolean): Promise<Product[]> {
    const [resProducts, resAddons] = await Promise.all([
        apiCall({ urlComponent: "/products", publicCall: true, query: { all } }),
        apiCall({ urlComponent: "/addons", publicCall: true, query: { all } }),
    ]);
    const [rawProducts, rawAddons] = await Promise.all([resProducts.json(), resAddons.json()]);
    const filteredProducts = rawProducts
        .map((rawProduct: any) => toProduct(rawProduct, rawAddons))
        .filter((p: Product | undefined) => !!p);
    const productMap = toProductMap(filteredProducts);

    for (const rawProduct of rawProducts) {
        addLinkedToProduct(rawProduct, productMap);
    }

    return filteredProducts;
    // return (await getProductsMock()).map(toProduct);
}

export async function getTaxRate(): Promise<BEStripe.TaxRate> {
    const res = await apiCall({
        urlComponent: "/taxRates/default",
        publicCall: true,
    });
    return await res.json();
}

export async function getPromotionCode(code: string): Promise<BEStripe.PromotionCode | undefined> {
    try {
        const res = await apiCall({
            urlComponent: `/promotionCodes/${code}`,
            method: HttpMethod.GET,
            publicCall: true,
        });
        return res.json();
    } catch (e) {
        console.log(e);
    }
}
